import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Params } from '@angular/router';
import { AuthService } from '../../../core/auth.service';
import { SHARED_MATERIAL_IMPORTS } from '../../shared-imports';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
  imports: SHARED_MATERIAL_IMPORTS,
})
export class ErrorPageComponent {
  public authservice = inject(AuthService);
  private route = inject(ActivatedRoute);

  private readonly queryParams = toSignal(this.route.queryParams, {
    initialValue: {} as Params,
  });

  public readonly statusCode = computed<number | undefined>(() => {
    const code = Number(this.queryParams()['code']);
    return code ? code : undefined;
  });

  public readonly content = computed(() => this.getContent(this.statusCode()));

  public retry(): void {
    window.location.reload();
  }

  async relogin(): Promise<void> {
    await this.authservice.waitForIdleInteraction();
    this.authservice.logoutAccount();
  }

  private getContent(statusCode?: number) {
    switch (statusCode) {
      case 401:
        return {
          title: `${statusCode} Unauthorized`,
          message: 'Your session has expired. Please sign in again.',
          icon: 'lock',
        };
      case 403:
        return {
          title: `${statusCode} Forbidden`,
          message: 'You do not have permission to access this page.',
          icon: 'lock',
        };
      case 404:
        return {
          title: `${statusCode} Page not found`,
          message: 'We could not find the page you requested.',
          icon: 'search_off',
        };
      case 500:
        return {
          title: `${statusCode} Internal Server Error`,
          message: 'Our servers are having issues. Please try again later.',
          icon: 'cloud_off',
        };
      default:
        return {
          title: 'Something went wrong',
          message: 'We could not verify your session. Signing in again usually resolves this.',
          icon: 'error_outline',
        };
    }
  }
}
